module.exports = __webpack_public_path__ + "img/zpfs.e7424ea9.png";